import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';
import { FormTextArea } from 'src/shared/components/form-components/form-text-area/form-text-area';

import { TextArea } from '../../../../shared/entities/control-entities';

type Props = {
  className?: string;
  label?: string;
  item: TextArea;
  isDisabled: boolean;
  onBlur?: VoidFunction;
  onChange(value: string): void;
};

export const NewWellTextArea = observer(function NewWellTextArea({
  className,
  label,
  item,
  isDisabled,
  onBlur,
  onChange,
}: Props) {
  const localOnChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value);
  };

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FormTextArea
      value={item.value}
      label={label}
      className={className}
      isError={!!item.errorText}
      errorText={item.errorText}
      placeholder={item.placeholder}
      isDisabled={isDisabled}
      onChange={localOnChange}
      onFocus={item.clearError}
      onBlur={handleBlur}
    />
  );
});
